module.exports = __webpack_public_path__ + "tw.svg";